import React, { useEffect, useState } from "react";
import "./Cancelled_Order_Details.css";
import { Link } from "react-router-dom";
import Blue_Btn from "../../../common-components/common_btn/blue_btn/Blue_Btn";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Brown_btn from "../../../common-components/common_btn/brown_btn/Brown_btn";
import Cancel_Reason_Modal from "../../../common-components/common_modal/cancel_reason_modal/Cancel_Reason_Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelOrder,
  getOrder,
  getSingleCancelOrder,
} from "../../../../features/order/orderSlice";
import { encodeId, OrderStatusIds } from "../../../../utils/common";
import { getAllCancelReason } from "../../../../features/master/masterSlice";
import Success_Modal_LogOut from "../../../common-components/common_modal/success_modal/Success_Modal_logOut";
import { useNavigate } from "react-router-dom";
import Delete_Modal from "../../../common-components/common_modal/delete_modal/Delete_Modal";

const Cancelled_Order_Details = ({
  selectedOrder,
  showBackButton,
  goBack,
  showCheckBox = false,
}) => {
  const dispatch = useDispatch();

  const order = useSelector((state) => state.order.cancelOrder);

  useEffect(() => {
    dispatch(getAllCancelReason());
  }, [dispatch]);

  const fetch = async (selectedOrder) => {
    await dispatch(
      getSingleCancelOrder({
        id: selectedOrder?.id,
        order_status_id: selectedOrder.order_status_id,
      }),
    );
  };

  useEffect(() => {
    if (selectedOrder) {
      fetch(selectedOrder);
    }
  }, [dispatch, selectedOrder]);

  const isProductUnavailable =
    order?.Product?.deletedAt || !order?.Product?.status;

  return (
    <section className="Cancelled_Order_Details">
      <div className="back_main_div">
        <button className="back_btn" onClick={goBack}>
          <FontAwesomeIcon icon={faArrowLeft} /> Back
        </button>
      </div>
      <div className="row">
        <div className="col-lg-7">
          <div className="details_main_div">
            {order?.id && (
              <Link
                to={
                  isProductUnavailable
                    ? ""
                    : `/product-details/${encodeId(order?.Product?.id)}`
                }
                className="detail_top_div"
              >
                {" "}
                <div className="detail_top_img">
                  {" "}
                  <div className="detail_img">
                    {" "}
                    <img
                      src={
                        process.env.REACT_APP_IMG_URL + order?.Product?.image
                      }
                      className="top_img"
                      alt="product_img"
                    />{" "}
                  </div>{" "}
                  <p className="top_text">
                    {" "}
                    {order?.Product?.name} -{" "}
                    {order?.Product_Variant?.Metal?.name || ""}{" "}
                    {order?.Product?.Unit?.name || ""}{" "}
                  </p>{" "}
                </div>{" "}
                <p className="quantity">x{order?.quantity || ""}</p>{" "}
              </Link>
            )}

            <div className="dark_div">
              <p className="dark_text">
                <span className="label">Street: </span>{" "}
                <span className="value">
                  {" "}
                  {order?.Product_Order?.User_Address?.building}
                </span>
              </p>

              <p className="dark_text">
                <span className="label"> City:</span>{" "}
                <span className="value">
                  {order?.Product_Order?.User_Address?.Users_Address_Detail
                    ?.City?.name || ""}
                </span>
              </p>

              <p className="dark_text">
                <span className="label">State:</span>{" "}
                <span className="value">
                  {" "}
                  {order?.Product_Order?.User_Address?.Users_Address_Detail
                    ?.State?.name || ""}
                </span>
              </p>

              <p className="dark_text">
                <span className="label">Pincode:</span>{" "}
                <span className="value">
                  {" "}
                  {order?.Product_Order?.User_Address?.Users_Address_Detail
                    ?.Pincode?.name || ""}
                </span>
              </p>
              {order?.Order_Cancellation && (
                <p className="dark_text">
                  <span className="label">Cancel Reason :</span>{" "}
                  <span className="value">
                    {order?.Order_Cancellation?.Cancel_Reason?.name ??
                      order?.Order_Cancellation?.message ??
                      ""}
                  </span>
                </p>
              )}
              {order?.Order_Rejection && (
                <p className="dark_text">
                  <span className="label">Reject Reason :</span>{" "}
                  <span className="value">
                    {order?.Order_Rejection?.message ?? ""}
                  </span>
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="col-lg-5 summary-card">
          <div className="details_main_div">
            <p className="right_title">Payment Summary</p>

            <div className="total_div">
              <p className="sub_text">Subtotal</p>
              <p className="sub_number">
                ₹{Number(order?.total_selling_price || 0).toFixed(2)}
              </p>
            </div>

            <div className="total_div ">
              <p className="sub_text">Shipping</p>
              <p className="sub_number">
                ₹{Number(order?.delivery_charges || 0).toFixed(2)}
              </p>
            </div>
            <div className="total_div ">
              <p className="sub_text">Offer Discount</p>
              <p className="sub_number">
                ₹
                {(
                  Number(
                    order?.total_offer_discount || order?.offer_discount,
                  ) || 0
                ).toFixed(2)}
              </p>
            </div>
            <div className="total_div ">
              <p className="sub_text">Coupon Discount</p>
              <p className="sub_number">
                ₹
                {(
                  Number(
                    order?.total_coupon_discount || order?.coupon_discount,
                  ) || 0
                ).toFixed(2)}
              </p>
            </div>
            <div className="total_div ">
              <p className="sub_text">Tax</p>
              <p className="sub_number">
                ₹{(Number(order?.total_tax) || 0).toFixed(2)}
              </p>
            </div>

            <div className="last_div">
              <p className="sub_text">Total</p>
              <p className="sub_number">
                ₹{Number(order?.total_amount || 0).toFixed(2)}
              </p>
            </div>
          </div>
        </div>
      </div>{" "}
    </section>
  );
};

export default Cancelled_Order_Details;
